import { useState } from "react";
import { Button, Typography } from "antd";
import { TbRefreshDot } from "react-icons/tb";
import { ApiService } from "api/api.service";
import { Resource } from "dtos/stage.dto";
import { taskUi } from "components/TaskBoard/design";
import { BoardSyncDrawer } from "components/TaskBoard/Drawer";

interface BoardSyncBannerProps {
  selector: string;
  resource: Resource;
}

/**
 * Silent until a template moves ahead of this application's boards. Shares its query with
 * the drawer, so opening the review costs nothing.
 */
export const BoardSyncBanner = ({ selector, resource }: BoardSyncBannerProps) => {
  const [open, setOpen] = useState(false);
  const drift = ApiService.taskBoard.useGetDrift(selector, resource);

  const count = drift.data?.actionable ?? 0;
  if (!count) return null;

  const missing = (drift.data?.entries ?? []).filter((entry) => entry.kind === "missing").length;
  const behind = count - missing;

  const detail = [
    behind ? `${behind} board${behind === 1 ? "" : "s"} behind` : null,
    missing ? `${missing} not started` : null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <>
      <div
        className="flex items-center gap-2.5 border border-solid"
        style={{
          padding: "10px 14px",
          borderColor: taskUi.indigoLine,
          background: taskUi.indigoSoft,
          borderRadius: taskUi.radius,
        }}
      >
        <TbRefreshDot size={16} color={taskUi.indigo} style={{ flexShrink: 0 }} />
        <Typography.Text style={{ fontSize: 13, flexGrow: 1 }}>
          Template updates are available
          <span style={{ color: taskUi.textFaint, marginLeft: 8, fontSize: 12.5 }}>{detail}</span>
        </Typography.Text>
        <Button type="primary" size="small" onClick={() => setOpen(true)}>
          Review
        </Button>
      </div>

      <BoardSyncDrawer open={open} onClose={() => setOpen(false)} selector={selector} resource={resource} />
    </>
  );
};
